var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Thumbnails = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M7.6 1.5V7.6H1.5V1.5H7.6ZM9.1 0H0V9.1H9.1V0Z" }),
    React.createElement("path", { fill: "currentColor", d: "M18.5 1.5V7.6H12.4V1.5H18.5ZM20 0H10.9V9.1H20V0Z" }),
    React.createElement("path", { fill: "currentColor", d: "M7.6 12.4V18.5H1.5V12.4H7.6ZM9.1 10.9H0V20H9.1V10.9Z" }),
    React.createElement("path", { fill: "currentColor", d: "M18.5 12.4V18.5H12.4V12.4H18.5ZM20 10.9H10.9V20H20V10.9Z" }))); });
//# sourceMappingURL=Thumbnails.js.map